<div class="p-3">
  <h2 mat-dialog-title>Reportar un problema</h2>
  <div mat-dialog-content>

    <p>Ayúdanos a mejorar reportando cualquier problema que encuentres</p>
    <br>
    <h5>Describe el problema</h5>
    <p>Cuéntanos qué ha ocurrido y cómo podemos reproducirlo</p>
    <textarea class="w-100 form-control" [(ngModel)]="userFeedback" placeholder="Describe el problema que encontraste..."></textarea>

  </div>
  <div mat-dialog-actions class="d-flex justify-content-between mt-3">
    <button class="btn btn-outline-levelab" (click)="close()" [disabled]="sending">Cerrar</button>
    <button class="btn btn-levelab" (click)="sendFeedback()" [disabled]="!userFeedback.trim() || sending">
      {{ sending ? 'Enviando...' : 'Enviar reporte' }}
    </button>
  </div>
</div>